import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContract = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_552_3391)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.37633 4.82229V0.268188L1.13867 5.5062H5.69242C6.18465 5.5062 6.37633 5.31452 6.37633 4.82229Z",
				fill: "#1B1B1B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.9585 7.04039L17.7497 5.83164C17.5392 5.62105 17.1982 5.6214 16.9877 5.83164L16.2041 6.61523L18.1752 8.58609L18.9585 7.8021C19.1687 7.59156 19.1691 7.25062 18.9585 7.04039Z",
				fill: "#1B1B1B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.52297 17.8627C7.35586 17.9052 7.17898 17.8567 7.05703 17.7347C6.93508 17.6128 6.88625 17.4355 6.92871 17.2684L8.06234 12.806L14.2524 6.61523L14.7486 6.11934L15.8459 5.02172L16.012 4.85598C16.0699 4.79801 16.1356 4.75152 16.1993 4.70203V0.886055C16.1993 0.397539 15.8014 0 15.3126 0H7.38922V5.43172C7.38922 6.03105 6.90172 6.51891 6.30273 6.51891H0.882812V19.1133C0.882812 19.6021 1.28066 20 1.76953 20H15.3126C15.8014 20 16.1993 19.6021 16.1993 19.1133V12.5129L11.9851 16.7278L7.52297 17.8627Z",
				fill: "#1B1B1B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.30621 13.5135L8.63477 16.1561L11.277 15.484L17.8161 8.94421L15.8457 6.97339L9.30621 13.5135ZM10.542 13.9612L10.0942 13.5135L15.7918 7.81589L16.2398 8.26397L10.542 13.9612Z",
				fill: "#1B1B1B"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_552_3391",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgContract;
